import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UNAUTHORIZED_EVENT } from '../api/ApiServices';

const AuthListener = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleUnauthorized = () => {
      console.log('Unauthorized event detected, navigating to login...');
      navigate('/login');
    };

    window.addEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);

    return () => {
      window.removeEventListener(UNAUTHORIZED_EVENT, handleUnauthorized);
    };
  }, [navigate]);

  return null;
};

export default AuthListener;